import isNil from 'lodash/isNil';

export type IEnvVariables = {
  BASE_URL: string;
  NOTIFICATIONS_BASE_URL: string;
  VOL_BASE_URL: string;
  ECOMMERCE_BASE_URL: string;
  CUSTOMER_BASE_URL: string;
  INTERNAL_BASE_URL: string;
  PRODUCER_BASE_URL: string;
  ENV: string;
  DOC_URL: string;
  SINGLE_SIGNON: string;
  CLIENT_SECRET: string;
};

const getEnvVar = (key: keyof IEnvVariables, prefix: string = 'VITE_APP_'): string => {
  const envKey = `${prefix}${key}`;
  const value = import.meta.env[envKey];

  if (isNil(value)) {
    console.error(`Variável de ambiente ${envKey} não encontrada`);
  }

  return value || null;
};

const createEnvProxy = <T extends IEnvVariables>(prefix: string = 'VITE_APP_'): T =>
  new Proxy({} as unknown as T, {
    get: (_, prop: string) => getEnvVar(prop as keyof IEnvVariables, prefix),
  });

const env = createEnvProxy<IEnvVariables>('VITE_APP_');

export default env;
